module.exports = __webpack_public_path__ + "static/media/menu-envelope.30fa73fe.svg";